<script lang="ts" setup>
import type { DuplicateResult } from '@/objects/generated';
defineProps<{
    value: Array<DuplicateResult>;
}>();
</script>
<template>
    <div>
        <span v-if="value.length > 0">
            {{ value[0].Name }}
        </span>
        <span v-if="value.length > 1"> {{ ' ' + (value.length - 1) }} {{ $tm('general.additional') }}... </span>
    </div>
</template>
